import imageUploaderMapper from './imageUploaderMapper';

export default function ctaMapper(componentsData) {
  return {
    ...componentsData,
    imageUploader: imageUploaderMapper(componentsData?.imageUploader),
    imageGenerator: componentsData?.aiImageGenerator,
  };
}
